import Event from '@components/event/Event'
import { Event as EventModel } from '@models/Event'
import { DndGrid } from '@pages/venues/detail/tabs/DndGrid'
import { useAppSelector } from '@store/hooks'
import { selectEventsByIds } from '@store/membership/EventReducer'
import { SBModelsComponent } from '@supplement-bacon/react-toolkit/models'
import { Card, Empty, Flex } from 'antd'

type Props = SBModelsComponent<EventModel> & {
  onUpdate: (data: any) => void
  displayMode: 'full' | 'condensed'
  dynamic: boolean
}

const EventsCollectionCollection = ({
  models,
  ids,
  onUpdate,
  displayMode,
  dynamic,
}: Props) => {
  const items = models ?? useAppSelector(selectEventsByIds(ids ?? []))

  if (!items || items.length === 0) {
    return (
      <Flex justify="center" className="w-full">
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={'No events in this collection'}
        />
      </Flex>
    )
  }
  if (dynamic) {
    return (
      <Flex gap={16}>
        {items.map((event) => (
          <Card
            key={event.id}
            style={{
              width: 250,
              borderRadius: 12,
              height: '100%',
              overflow: 'hidden',
            }}
            styles={{
              body: { padding: 0 },
            }}
          >
            <Event.Avatar id={event.id} displayMode={displayMode} />
          </Card>
        ))}
      </Flex>
    )
  }

  return (
    <Flex gap={16}>
      <DndGrid<EventModel>
        items={items}
        styles={{
          idle: { cursor: 'move' },
          dragging: { opacity: 0.4 },
          over: { borderLeft: 0.4 },
        }}
        onItemsChange={(updatedEvents) => onUpdate(updatedEvents)}
        renderItem={(item, _, ref) => (
          <Card
            ref={ref}
            style={{
              width: 250,
              borderRadius: 12,
              height: '100%',
              overflow: 'hidden',
            }}
            styles={{
              body: { padding: 0 },
            }}
          >
            <Event.Avatar model={item} displayMode={displayMode} />
          </Card>
        )}
      />
    </Flex>
  )
}

type EventsCollectionCollectionType = {
  Collection: typeof EventsCollectionCollection
}

export { EventsCollectionCollection, type EventsCollectionCollectionType }
